import styled from '@emotion/styled';

export const HiddenTitle = styled.h1`
  visibility: hidden;
  height: 0;
`;
